import {
  requestGetModelMailDefaultScellement,
  requestGetModelMailDefaultSignature,
} from "@/state/modelMail/ModelMailEffects";
import { useCurrentTransaction } from "@/state/transactions/CurrentTransactionHook";
import { toastError } from "@/utils/helpers/toast-helper";
import SubmitButton from "@components/core/buttons/SubmitButton";
import { SelectFormField } from "@components/core/inputs/SelectFormField";
import { signatureService } from "@services/signatureService";
import { useOffices } from "@state/offices/OfficesHook";
import { setCurrentTransactionField } from "@state/transactions/CurrentTransactionEvents";
import { formValidateTriggers } from "@utils/Constant";
import { Col, Form, Row } from "antd";
import { FunctionComponent, useEffect } from "react";
import { SignatureScreenSectionProps } from "@views/core/extranet/transactions/signature/SignatureScreen";
import { useTranslation } from "react-i18next";

interface OfficeChoiceSectionProps extends SignatureScreenSectionProps {
  className?: string;
  preselectedOfficeId?: string;
  disabled?: boolean;
}

interface OfficeChoiceProps {
  office: string;
  preselectedOfficeId: string;
}

const OfficeChoiceSection: FunctionComponent<OfficeChoiceSectionProps> = ({
  onSubmit,
  className = "",
  preselectedOfficeId,
  disabled,
}) => {
  const { t } = useTranslation();
  const { selectedOffices } = useOffices();
  const { transactionType, transactionForm } = useCurrentTransaction();

  useEffect(() => {
    return requestGetModelMailDefaultSignature.done.watch(({ result }) => {
      if (
        result.ok &&
        result.data?.invitation &&
        result.data.endOfTransaction
      ) {
        setCurrentTransactionField([
          {
            field: "invitation",
            value: result.data.invitation,
          },
          {
            field: "endOfTransaction",
            value: result.data.endOfTransaction,
          },
        ]);
      } else {
        toastError(t("error.toast.modelMail.retrieve"));
      }
    });
  });

  useEffect(() => {
    return requestGetModelMailDefaultScellement.done.watch(({ result }) => {
      if (
        result.ok &&
        result.data?.invitation &&
        result.data.endOfTransaction
      ) {
        setCurrentTransactionField([
          {
            field: "invitation",
            value: result.data.invitation,
          },
          {
            field: "endOfTransaction",
            value: result.data.endOfTransaction,
          },
        ]);
      } else {
        toastError(t("error.toast.modelMail.retrieve"));
      }
    });
  });

  const InitialValues = {
    office: preselectedOfficeId,
  };

  const handleSubmit = (values: OfficeChoiceProps) => {
    onSubmit?.();
    // TODO setSignatureFormAttribute("office", values.officeId) / setScellementFormAttribute("office", values.officeId)
    const transactionOffice = selectedOffices.find(
      (o) => o.id === values.office,
    );

    setCurrentTransactionField([
      { field: "office", value: values.office },
      {
        field: "confidential",
        value: signatureService.computeConfidentiality(
          transactionOffice,
          transactionForm,
        ),
      },
      { field: "authorizedExpertForConfidentiality", value: [] },
    ]);

    if (transactionType === "signature") {
      void requestGetModelMailDefaultSignature({ id: values.office });
    } else if (transactionType === "scellement") {
      void requestGetModelMailDefaultScellement({ id: values.office });
    }
  };

  return (
    <Row
      className={`app-section-office-choice justify-content-center ${className}`}
    >
      <Col span={24} lg={20} xl={16}>
        <Form
          onFinish={handleSubmit}
          initialValues={InitialValues}
          {...formValidateTriggers}
          layout="vertical"
          requiredMark={false}
        >
          <SelectFormField
            disabled={disabled || !!transactionForm.id}
            showLabel
            module="signature.accordion.officeForm"
            field="office"
            options={
              selectedOffices.map((office) => ({
                label: office.alias,
                value: office.id,
              })) ?? []
            }
            required
          />
          <div className="d-flex align-items-center justify-content-end pt-30">
            <SubmitButton
              label={"buttons.validate"}
              className="mw-160"
              dataAlt={t("buttons.validate")}
            />
          </div>
        </Form>
      </Col>
    </Row>
  );
};

export default OfficeChoiceSection;
